import { Locale } from '../types/locale';

export function detectBrowserLocale(lang?: string): Locale {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const nav = typeof globalThis !== 'undefined' ? (globalThis as any).navigator : undefined;
  const language = lang ?? (nav?.language ?? '');
  if (language.startsWith('zh')) return Locale.ZH_CN;
  return Locale.EN_US;
}
